import styled from "styled-components";

import Grid from "core/Grid";
import Heading from "core/Heading";
import BodyText from "core/BodyText";
import Button from "core/Button";

import { convertPxToRem } from "frontend/components/helpers";

export const SupportingIcons = styled.div`
    svg,
    img {
        max-height: ${convertPxToRem({ px: 40 })};
        margin-right: ${convertPxToRem({ px: 20 })};

        &:last-of-type {
            margin-right: 0;
        }
    }
`;

export const GridItem = styled(Grid)`
    ${Heading},
    ${SupportingIcons},
    ${BodyText} {
        margin-bottom: ${convertPxToRem({ px: 24 })};
    }

    ${Button} {
        margin-right: ${convertPxToRem({ px: 16 })};

        &:last-of-type {
            margin-right: 0;
        }
    }
`;
